import { render, staticRenderFns } from "./cat-text-overflow.vue?vue&type=template&id=6c901140&"
import script from "./cat-text-overflow.vue?vue&type=script&lang=js&"
export * from "./cat-text-overflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports